import { createContext, useContext, useState } from 'react';

const AutoplayContext = createContext(null);

export const AutoplayProvider = ({ children }) => {

  const autoplayState = useState(false);

  return (
    <AutoplayContext.Provider value={autoplayState}>
      {children}
    </AutoplayContext.Provider>
  );
};

export const useAutoplayContext = () => useContext(AutoplayContext);